import "./Disclaimer.module.css";
import Header from "@/reusable_sections/Header";
import LegalDisclaimer from "./sections/LegalDisclaimer";
import Footer from "@/reusable_sections/Footer";
export default function DisclaimerPage() {
  return <div>
      <Header />
      <LegalDisclaimer />
      <Footer />
    </div>;
}